import xeroxLocalApi from '../axios/xeroxLocalApi';

class SlaViewService {

    async getJobName() {
        // return Promise.resolve(xeroxLocalApi.get(`slaView.json`));
    }
    async getSlaList() {
        // return Promise.resolve(xeroxLocalApi.get(`slaList.json`));
    }
}

export default SlaViewService;